import View from './view.js'

export default function Logic(props) {
  return <View {...props} onClick={onClick} />

  function onClick(e) {
    // stop propagation to prevent automatically opening a patient's treatment card
    e.stopPropagation()
  }
}
